import { Button, Flex, Select, Stack } from '@mantine/core';
import { useState } from 'react';
import { NewMarkdownEditor } from 'src/common/components/markdown-editor/MarkdownEditor';
import { GroupedSuggestions } from 'src/common/components/markdown-editor/plugins/SuggestionTrackerPlugin';

const content = `Example document for testing the editor. Contains a variety of markdown and HTML the editor should support, as well as some manual tests at the end (e.g. pasting markdown).
# MD Elements

## Table with suggestions

| Name | Age | Location | Favorite Color |
| ---- | --- | -------- | -------------- |
| Bob  | 30  | New York | Blue           |
| Alice| 25 | <suggestion>New York</suggestion> | Red            |
| Jane | 35 | New <suggestion source="note">added</suggestion> York | Green          |

## Text with suggestions from two sources
Here's inline text with <suggestion>default suggestion</suggestion> and <suggestion source="note">note suggestion</suggestion>.

## Code block

\`\`\`js
function helloWorld() {
  console.log('Hello, world!');
}
\`\`\`

## Suggestion block
<suggestion>
Here's a default suggestion block with a link: [Google](https://www.google.com)

And a list:

- Item 1
- Item 2
- Item 3
</suggestion>

# HTML
## HTML tag with a mix of HTML child elements
<html>
<h1>h1</h1>
<suggestion source="note">
Suggestion from a note
</suggestion>
<br/>
And an <suggestion source="note">inline note suggestion</suggestion>.
<p>
And a <suggestion>non-note suggestion</suggestion>.
</p>
<table>
  <tr>
    <td>Cell 1</td>
    <td>Cell 2</td>
  </tr>
</table>
</html>

## Top-level BR tag
<br/>

## Top-level Table tag
<table>
  <tr>
    <td>Cell 1</td>
    <td>Cell 2</td>
  </tr>
</table>


# Markdown after HTML

## Suggestion block with a list inside
<suggestion source="note">
Here's a note suggestion block:

- Note item 1
- Note item 2
</suggestion>

## Numbered list

1. Item 1
2. Item 2
3. Item 3

## Quote

> This is a quote

## Invalid source (should fallback to default)
Testing invalid source (should fallback to default): <suggestion source="invalid">This should be default styled</suggestion>

# Manual tests
## Paste markdown test
Paste this markdown into the editor:

\`\`\`
**bolded text**
\`\`\`
  
  
  

Paste this HTML table into the editor:

\`\`\`
<table>
  <tr>
    <td>Cell 1</td>
    <td>Cell 2</td>
  </tr>
</table>
\`\`\`
  
  
  
`;
export default function EditorPlaygroundTab() {
  const [value, setValue] = useState(content);
  const [suggestions, setSuggestions] = useState<GroupedSuggestions>({ default: {}, note: {} });

  return (
    <Stack gap="xs">
      <Flex justify="end" gap="md" align="end">
        <Select
          label="Default Suggestions"
          placeholder="Select to scroll"
          data={Object.values(suggestions.default).map(s => ({
            value: s.key,
            label: s.textContent.slice(0, 50) || '(empty)',
          }))}
          onChange={key => key && suggestions.default[key]?.scrollIntoView()}
          clearable
        />
        <Select
          label="Note Suggestions"
          placeholder="Select to scroll"
          data={Object.values(suggestions.note).map(s => ({
            value: s.key,
            label: s.textContent.slice(0, 50) || '(empty)',
          }))}
          onChange={key => key && suggestions.note[key]?.scrollIntoView()}
          clearable
        />
        <Button
          variant="outline"
          onClick={() => {
            // eslint-disable-next-line no-console
            console.log(value);
          }}
        >
          Export to dev console
        </Button>
      </Flex>
      <NewMarkdownEditor
        onChange={setValue}
        defaultValue={content}
        onSuggestionsChange={setSuggestions}
      />
    </Stack>
  );
}
